export const environment = {
  production: true,
  apiBaseUrl: 'https://dev.api.pdp.natific.com/',
  apiPortalUrl: 'https://dev.portal.pdp.natific.com/api/',
  portalUrl: 'https://dev.portal.pdp.natific.com/',
  applicationId: '<TO BE DEFINED!!!>',
  requiresSubscription: false
};
